import React, { Fragment, ReactNode, useEffect } from 'react';
import { useSiteDefinition } from 'src/core/provider/SiteProvider';

interface SiteLayoutProps {
    children: ReactNode;
}

const SiteLayout: React.FC<SiteLayoutProps> = ({ children }) => {
    const site = useSiteDefinition();
    const Shell = site.shell ?? Fragment;

    useEffect(() => {
        if (site.tabTitle) {
            document.title = site.tabTitle;
        }
        if (site.faviconUrl) {
            ['icon', 'shortcut icon'].forEach(rel => {
                document.querySelectorAll<HTMLLinkElement>(`link[rel="${rel}"]`).forEach(link => {
                    link.href = site.faviconUrl!;
                });
            });
        }
    }, [site.id]);

    return <Shell site={site}>{children}</Shell>;
};

export default SiteLayout;
